import { faArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@design-system/components/button/button';
import { clsx } from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useElementObserver } from '@client/new/hooks/useElementObserver';

export const BackToTop = ({ observedId }: { observedId: string }) => {
  const { isVisibleInViewport } = useElementObserver({ observedId });

  const scrollToTop: React.MouseEventHandler<HTMLButtonElement> = (ev) => {
    ev.preventDefault();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <Button
      onClick={scrollToTop}
      color="neutral"
      className={clsx(
        'rounded-[50px] w-[50px] h-[50px]',
        isVisibleInViewport && 'invisible',
        !isVisibleInViewport && 'visible fixed bottom-20 right-5',
      )}
      id="backToTop"
    >
      <FontAwesomeIcon icon={faArrowUp} className="w-5 h-5" />
    </Button>
  );
};
